import { render, staticRenderFns } from "./EcDrawer.vue?vue&type=template&id=f2e1e2b6"
import script from "./EcDrawer.vue?vue&type=script&lang=js"
export * from "./EcDrawer.vue?vue&type=script&lang=js"
import style0 from "./EcDrawer.vue?vue&type=style&index=0&id=f2e1e2b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports